// extracted by mini-css-extract-plugin
module.exports = {"input":"TextInput-module--input--18wMB","error":"TextInput-module--error--2WICY","label":"TextInput-module--label--1H1kk","required":"TextInput-module--required--3KDXw"};